module.exports = __webpack_public_path__ + "img/logo_keler_white.0508e95e.svg";